import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getTenants } from "store/actions/Tenants";
import { RootState } from 'store/store';
//@ts-ignore
import Select from 'react-select'
import { TenantState } from 'store/reducers/Tenants';
import {useOfficeTranslation} from 'i18n/OfficeTranslation';

interface Props {
    tenantState: TenantState;
}

interface Actions {
    getTenants: () => void;
}

const ExpenseAddButton: React.FC<Props & Actions> = ({ tenantState, getTenants }) => {
    const {t} = useOfficeTranslation();

    const navigate = useNavigate();

    const [tenantId, setTenantId] = useState<string>("")
    const [addAction, setAddAction] = useState<boolean>(false)
    const [error, setError] = useState("")

    useEffect(() => {
        getTenants()
    }, [getTenants])

    if (addAction) {
        return (
            <div className="expense-add-action">
                <div className="d-flex align-items-center gap-2">
                    <div className="flex-grow-1">
                        <Select
                            aria-label={t("common.chooseTenant")}
                            options={tenantState.getTenants().map(tenant => ({
                                value: tenant.id,
                                label: tenant.name,
                            }))}
                            onChange={(object: any) => {
                                setTenantId(object.value);
                                setError("");
                            }}
                            placeholder={t("expenses.expenseAddButton.chooseTenant")}
                        />
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary text-nowrap"
                        onClick={() => {
                            if (tenantId) {
                                navigate("/tenants/" + tenantId + "/expenses/add")
                                setAddAction(false)
                            } else {
                                setError(t("common.chooseTenant"));
                            }
                        }}
                    >
                        {t("expenses.expenseAddButton.continue")}
                    </button>
                    <button
                        aria-label={t("expenses.expenseAddButton.cancelAddingExpense")}
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                            setAddAction(false)
                            setError("")
                        }}
                    >
                        <i className="mdi mdi-close" />
                    </button>
                </div>
                {error && <small className="text-danger d-block mt-1">{error}</small>}
            </div>
        );
    }

    return (
        <button
            type="button"
            className="btn btn-primary"
            onClick={() => setAddAction(true)}
        >
            <i className="mdi mdi-plus me-1" />
            {t("common.addExpense")}
        </button>
    );
}

const mapStateToProps = (state: RootState) => {
    return {
        tenantState: state.Tenants,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ getTenants }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpenseAddButton);
